import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, Check, FileSpreadsheet, FlaskConical, Gem, Lightbulb, Moon, Palette, Pipette, ShieldCheck, Sparkles } from 'lucide-react';
import emeraldCluster from '../assets/excel-after-dark/emerald-cluster-v2.png';

const colourRows = [
  { swatch: '#e91e63', hex: '#E91E63', rgb: '233, 30, 99' },
  { swatch: '#217346', hex: '#217346', rgb: '33, 115, 70' },
  { swatch: '#8e24aa', hex: '#8E24AA', rgb: '142, 36, 170' },
  { swatch: '#f5a623', hex: '#F5A623', rgb: '245, 166, 35' },
];

export function ExcelAfterDarkHome() {
  return <div className="ead-home">
    <section className="ead-hero"><div className="ead-shell ead-hero-grid">
      <div className="ead-hero-copy">
        <span className="ead-eyebrow"><Moon size={16} /> Original tools, built after hours</span>
        <h1>Excel gets <em>interesting</em> after dark.</h1>
        <p>Independent Excel inventions for people who suspect there is more value hidden in every cell.</p>
        <div className="ead-actions">
          <Link className="ead-button ead-button-primary" to="/products/excel-colour-picker">Explore the Colour Picker <ArrowRight size={18} /></Link>
          <a className="ead-button ead-button-ghost" href="#emerald-seam">See what makes it different</a>
        </div>
      </div>
      <div className="ead-picker-demo" aria-label="Colour information captured into Excel">
        <div className="ead-picker-panel">
          <div className="ead-window-title"><Pipette size={17} /> Excel Colour Picker <span>×</span></div>
          <div className="ead-colour-field"><span /></div>
          <div className="ead-value-row"><strong>HEX</strong><code>#E91E63</code></div>
          <div className="ead-value-row"><strong>RGB</strong><code>233, 30, 99</code></div>
          <div className="ead-capture-label"><Check size={15} /> Ready to capture</div>
        </div>
        <div className="ead-sheet-panel">
          <div className="ead-sheet-head"><span>Colour</span><span>HEX</span><span>RGB</span></div>
          {colourRows.map(row => <div className="ead-sheet-row" key={row.hex}><i style={{backgroundColor: row.swatch}} /><code>{row.hex}</code><code>{row.rgb}</code></div>)}
        </div>
      </div>
    </div></section>

    <section className="ead-band ead-band-emerald" id="emerald-seam"><div className="ead-shell ead-band-grid">
      <div className="ead-band-copy">
        <span className="ead-kicker"><FileSpreadsheet size={17} /> Made for Microsoft Excel</span>
        <h2>Find the value hidden in every cell.</h2>
        <p>Pick any colour on your screen and write its RGB and HEX values directly into your worksheet—without detours through another website.</p>
        <ul className="ead-checks"><li><Check /> Capture colour straight to Excel</li><li><Check /> Keep a reusable colour history</li><li><Check /> Stay inside your Microsoft workflow</li></ul>
      </div>
      <div className="ead-emerald-scene" aria-label="Emerald crystals emerging from spreadsheet cells">
        <div className="ead-cell-grid" /><div className="ead-emerald-glow" />
        <img className="ead-emerald-cluster" src={emeraldCluster} alt="Glowing faceted emerald crystals and cut gemstones" />
        <span><Gem size={20} /> Excel emerald: capability made visible</span>
      </div>
    </div></section>

    <section className="ead-band ead-band-violet"><div className="ead-shell">
      <div className="ead-section-heading"><span className="ead-kicker"><FlaskConical size={17} /> Experiment and discover</span><h2>Tools Excel never knew it needed.</h2><p>We explore unusual ideas, test them against real work, and turn the best ones into focused tools.</p></div>
      <div className="ead-card-grid">
        <article className="ead-card"><Palette /><h3>See colour as data</h3><p>Move smoothly between visual decisions and exact worksheet values.</p></article>
        <article className="ead-card"><Sparkles /><h3>Try the unexpected</h3><p>Use Excel in ways that go well beyond ordinary formulas and reports.</p></article>
        <article className="ead-card"><ShieldCheck /><h3>Built for real work</h3><p>Focused utilities, clear instructions, and support when you need it.</p></article>
      </div>
    </div></section>

    <section className="ead-band ead-band-amber"><div className="ead-shell ead-maker-grid">
      <div><span className="ead-kicker"><Lightbulb size={17} /> Built by an independent maker</span><h2>Made after work. Built to change how you work.</h2></div>
      <div className="ead-maker-note"><p>Excel After Dark is where late-night ideas become useful Microsoft Excel tools—original creations inspired by problems that deserve better answers.</p><span>One idea at a time. Built with curiosity.</span></div>
    </div></section>

    <section className="ead-band ead-band-teal"><div className="ead-shell ead-support-grid">
      <div><span className="ead-kicker"><BookOpen size={17} /> Support and learning</span><h2>Useful tools should be understandable.</h2><p>Product guidance, practical Excel methods, and direct help when something does not work as expected.</p></div>
      <div className="ead-support-actions"><Link className="ead-button ead-button-teal" to="/products/excel-colour-picker">Discover the first tool <ArrowRight size={18} /></Link></div>
    </div></section>
  </div>;
}
